import React, { useEffect, useRef, useState } from 'react'
import {
  ENTITY_NAME,
  LAYOUT_TYPE_NAMESPACE,
  NAMESPACES,
  PAP_WORKFLOW_CONSTANTS,
  TASK_STATUS,
  TASK_TYPE_CONSTANTS,
  WORKFLOW_STATUS,
} from '../../utils/constants'
import {
  Panel,
  PanelGroup,
  ImperativePanelGroupHandle,
  PanelResizeHandle,
} from 'react-resizable-panels'
import {
  addToaster,
  createTaskApi,
  EVENT_CONSTANTS,
  fetchCommunicationIdCorrespondingData,
  flattenEntityRelationshipTree,
  generateCommuncationStatusesAPI,
  getEnableCall,
  getLayoutByIdApi,
  getLayoutTree,
  getWorkflowByEntityNameAndRecordId,
  hideLoader,
  LayoutResponseType,
  // resetWorkflowApi,
  resetWorkflowState,
  setDialPad,
  showLoader,
  SiteSettingsType,
  updateCaseData,
  updateCaseInfo,
  updateFaxDetailsReducer,
  updateRelationshipTree,
  updateRelationshipTreeObject,
  updateWorkflowDefinition,
  updateWorkflowInstance,
  updateWorkflowInstanceAdditionalKeys,
  WORKFLOW_UI_IDENTIFIER,
  WorkflowStepperObjectType,
} from '@app-store'
import {
  RootState,
  useAppDispatch,
  useAppSelector,
} from '../../utils/agent.store'
import TabLayout from '../../components/tabs/TabLayout'
import FormRenderer from '../../components/FormRenderer'
import { EntityLayout, LayoutData, Page } from '../../types/layout.types'
import {
  getCaseKeyCaseNameByEntity,
  getEntityData,
  getEntityDataByIdEntityNameEmbedded,
} from '../../apis/entityData.api'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import {
  CustomButton,
  FIELD_VALUE_CONSTANTS,
  StepType,
  StepperBV,
  SvgCallIconWorkflow,
  SvgFaxIconWorkflow,
  Tooltip,
  StepperType,
  SvgReload,
} from '@ui-kit'
import { isEmpty, noop } from 'lodash'
import WorkflowRightSplitTaskTable, {
  MoveToMIProcess,
} from '../../components/workflow/WorkflowRightSplitTaskTable'
import { FieldValues } from 'react-hook-form'
import WorkflowAddManualTaskModal from '../../components/Modal/WorkflowAddManualTaskModal'
import { v4 as uuid } from 'uuid'
import { TabIndexMap } from '../../types/common'
import { generateTabIndexMap } from '../../utils/tab-indexing'
import {
  ROWS_TAB_DIFFERENCE,
  ROWS_TAB_DIFFERENCE_FOR_WORK_FOW,
  ShortcutKeys,
} from '../../constants/form.constants'
import { FocusTrap } from 'focus-trap-react'
import StickySummary from '../../components/workflow/StickySummary'
import { isReadOnlyUser, isSuperAdmin } from '../../utils/permission'
import { useFocusFirstElement } from '../../hooks/useFocusFirstFocusableElement'
import LetterPreview from './LetterPreview'
import { FaxDetailsData } from '../../types/intakeQueue.types'
import { QUEUE_STRINGS } from '../../utils/queueIntake.types'
import CaseStateWorkflow from './CaseStateWorkflow'
import { STRINGS } from '../../utils/strings'
import SubStickySummary from '../../components/workflow/SubStickySummary'
import { fetchEntityIdByName } from '../../utils/helperFunctions'
import LeftSplitShimmer from './LeftSplitShimmer'
import { MissingInfoIcon } from './MissingInfoIcon'
import CheckEligibilityMaxRTE from '../../components/max-rte/CheckEligibilityMaxRTE'
import {
  CHECK_ELIGIBILITY_LOCATION,
  MAX_RTE_NAME_SPACE,
} from '../../utils/maxRTE'
import PatientEConsent from '../../components/e-consent/PatientEConsent'
// import { resetServiceWorkerDataCache } from '../../utils/service-worker.utils'

const WorkflowReview: React.FC = () => {
  const dispatch = useAppDispatch()
  const location = useLocation()
  const letterDataQuery = location.search.replace('?', '')
  const { entityId, caseId } = useParams()
  const MEC_PORTAL_BTN = true

  const navigate = useNavigate()
  const { user } = useAppSelector((store) => store?.authUser)
  const siteSettings = useAppSelector((state) => state?.authUser?.site_settings)
  const workflowInstance = useAppSelector(
    (state) => state?.workflowData?.workflowInstance
  )
  const workflowDefinition = useAppSelector(
    (state) => state?.workflowData?.workflowDefinition
  )
  const workflowInstanceAdditionalKeys = useAppSelector(
    (state) => state?.workflowData?.workflowInstanceAdditionalKeys
  )
  const caseDetailsVal = useAppSelector(
    (state) => state?.workflowData.caseDetails
  )
  const updatedTaskList = useAppSelector(
    (state) => state?.workflowData?.taskList
  )
  const caseData = useAppSelector((state) => state?.workflowData?.caseData)

  const [stepper, setStepper] = useState<StepType[]>([])
  const [completedStep, setCompletedStep] = useState<number>(0)
  const [viewLayout, setViewLayout] = useState<LayoutResponseType>()
  const [entityData, setEntityData] = useState<LayoutData>()

  const [caseDetails, setCaseDetails] = useState<FieldValues>({})
  const [isAddTask, setIsAddTask] = useState<boolean>(false)
  const [refetch, setRefetch] = useState<boolean>(false)
  const [tabIndexMap, setTabIndexMap] = useState<TabIndexMap>()
  const [faxDetails, setFaxDetails] = useState<FaxDetailsData | null>(null)
  const [isPrintLetterView, setIsPrintLetterView] = useState<boolean>(false)
  const [showMaxRTEIcon, setShowMaxRTEIcon] = useState<boolean>(false)
  const [communicationStatuses, setCommunicationStatuses] = useState<
    {
      label: string
      id: string
    }[]
  >([])

  const [isFetched, setIsFetched] = useState(false)
  const isFocusTrapActive = useRef<boolean>(false)
  const onFocus = useRef<boolean>(true)
  const tenantid = useAppSelector(
    (state) => state?.authUser?.selectedClientTenant?.id
  )

  const isLoggedInToAWS = useAppSelector(
    (state) => state?.appState.isLoggedInToAWS
  )
  const loaderVisible = useAppSelector(
    (state: RootState) => state?.loader.loading
  )
  const leftPanelRef = useRef<HTMLDivElement>(null)

  const programPermissions = useAppSelector(
    (state: RootState) => state.clientPermissions.programPermissions
  )
  const panelGroupRef = useRef<ImperativePanelGroupHandle>(null)
  useFocusFirstElement(leftPanelRef)

  const toggleAddTask = () => {
    setIsAddTask(!isAddTask)
  }

  const getUiIdentifierForTask = (taskType: string) => {
    if (taskType === TASK_TYPE_CONSTANTS?.FAX_OUTBOUND) {
      return WORKFLOW_UI_IDENTIFIER?.FAX_OUTBOUND_TASK
    } else if (taskType === TASK_TYPE_CONSTANTS?.DOCUMENT_GENERATION) {
      return WORKFLOW_UI_IDENTIFIER?.GENERATE_DOCUMENT
    } else if (taskType === TASK_TYPE_CONSTANTS?.CALL_OUTBOUND) {
      return WORKFLOW_UI_IDENTIFIER.MANUAL_CALL_OUTBOUND
    } else if (taskType === TASK_TYPE_CONSTANTS?.TEXT_OUTBOUND) {
      return WORKFLOW_UI_IDENTIFIER?.MANUAL_TEXT_OUTBOUND
    } else if (taskType === TASK_TYPE_CONSTANTS?.MAIL_OUTBOUND) {
      return WORKFLOW_UI_IDENTIFIER?.MAIL_OUTBOUND_TASK
    }
    return ''
  }

  const createTask = async (data: FieldValues) => {
    dispatch(showLoader())
    try {
      const uiIdentifier: string = getUiIdentifierForTask(
        data?.task_template?.name
      )
      const startDate = data?.startDate?.replace('.000Z', '+00:00') ?? ''
      const dueDate = data?.dueDate?.replace('.000Z', '+00:00') ?? ''
      await createTaskApi({
        case_id: caseId ?? '',
        name: data?.taskName ?? '',
        description: data?.taskSummary ?? '',
        due_date: dueDate ?? '',
        start_date: startDate ?? '',
        step_id: data?.taskName?.toLowerCase()?.replace(/\s+/g, '_'),
        state: data?.status ?? TASK_STATUS.PENDING,
        standalone: true,
        cancellable: true,
        record_status: TASK_STATUS.ACTIVE,
        notes: data?.taskSummary ?? '',
        process_instance_id: workflowInstance?.id ?? '',
        assignee: data?.assignee,
        task_template: data?.task_template,
        entity_type_name: data?.entityType,
        entity_name: data?.entityName,
        identifier: {
          taskNoteValues: {
            isTaskNoteSuggestionBox: true,
            isTaskNoteAddButton: false,
          },
          ui_identifier: uiIdentifier,
        },
        ...(Object.prototype.hasOwnProperty.call(data, 'requestor_view')
          ? { requestor_view: data.requestor_view }
          : {}),
      })
      !data?.blockPopup && toggleAddTask()
      setRefetch(!refetch)
    } catch (err) {
      console.error(err)
      dispatch(
        addToaster({
          message: NAMESPACES.SOMETHING_WENT_WRONG,
          type: 'error',
          id: uuid(),
        })
      )
    } finally {
      dispatch(hideLoader())
    }
  }
  const createCallTask = async (data: FieldValues) => {
    dispatch(showLoader())
    try {
      const tomorrowDate = new Date()
      tomorrowDate.setDate(tomorrowDate.getDate() + 1)
      const formattedTomorrow = tomorrowDate.toISOString().split('T')[0]
      await createTaskApi({
        case_id: caseId ?? '',
        name: data.taskName ?? '',
        description: data?.taskSummary ?? '',
        state: data?.status,
        standalone: true,
        record_status: 'ACTIVE',
        due_date: formattedTomorrow ?? '',
        process_instance_id: workflowInstance?.id ?? '',
      })
    } catch (err) {
      console.error(err)
    } finally {
      dispatch(hideLoader())
    }
  }

  const createFaxTask = async () => {
    dispatch(showLoader())
    try {
      const tomorrowDate = new Date()
      tomorrowDate.setDate(tomorrowDate.getDate() + 1)
      const formattedTomorrow = tomorrowDate.toISOString().split('T')[0]
      await createTaskApi({
        case_id: caseId ?? '',
        name: NAMESPACES?.RELAY_RESULTS,
        description: '',
        state: NAMESPACES?.PENDING,
        standalone: true,
        record_status: 'ACTIVE',
        due_date: formattedTomorrow ?? '',
        process_instance_id: workflowInstance?.id ?? '',
        identifier: {
          ui_identifier: WORKFLOW_UI_IDENTIFIER?.SEND_COMMUNICATION_FAX,
        },
        assignee: { id: user?.id },
      })
    } catch (err) {
      console.error(err)
    } finally {
      dispatch(hideLoader())
    }
  }

  const fetchLayoutData = async (layout: LayoutResponseType) => {
    try {
      const response = await getEntityData(
        layout?.entity_name,
        Number(layout?.entity_id),
        Number(layout?.id),
        caseId ?? 0
      )
      if (response?.data) {
        setEntityData(response.data)
      }
    } catch (err) {
      console.error(err)
    }
  }

  const fetchLayout = async (entityId: string, tabsLayoutId: string) => {
    dispatch(showLoader())

    setViewLayout(undefined)
    try {
      const response = await getLayoutByIdApi({
        entityId: entityId,
        layoutId: tabsLayoutId,
      })
      if (response?.data) {
        setViewLayout(response.data)
        if (response?.data?.type === LAYOUT_TYPE_NAMESPACE.OVERVIEW_TYPE) {
          await fetchLayoutData(response.data)
        }
      }
    } catch (err) {
      console.error(err)
    } finally {
      dispatch(hideLoader())
    }
  }

  const getStepperPosition = (stepper: StepperType[]) => {
    let activeStep = 0
    stepper.forEach((step, index) => {
      if (step?.keyName === workflowInstance?.current_group) {
        if (workflowInstance?.current_group_status === 'COMPLETED') {
          activeStep = index + 1
        } else {
          activeStep = index
        }
      }
    })
    setCompletedStep(activeStep)
  }

  const createStepper = async (stepperData: WorkflowStepperObjectType) => {
    if (!isEmpty(stepperData)) {
      const orderedSteps = Object.entries(stepperData)
        .map(([keyName, { label, order }]) => ({
          keyName,
          label: label ?? '',
          order,
        }))
        .sort((a, b) => a.order - b.order)
      setStepper(orderedSteps || [])
      getStepperPosition(orderedSteps)
    }
  }

  const startPollingWorkflow = () => {
    let attempts = 0
    const maxAttempts = 5
    const intervalTTL = 5000
    dispatch(
      updateWorkflowInstanceAdditionalKeys({
        ...workflowInstanceAdditionalKeys,
        isPolling: true,
      })
    )
    const pollInterval = setInterval(async () => {
      attempts++
      try {
        const result = await getWorkflowByEntityNameAndRecordId({
          recordId: caseId ?? '',
          entityName: 'case',
        })

        if (
          (result?.data?.workflow_instance?.state !==
            WORKFLOW_STATUS.PROCESSING_IN_BACKGROUND &&
            !result?.data?.background_jobs_active) ||
          attempts >= maxAttempts
        ) {
          if (pollInterval) clearInterval(pollInterval)
          if (result?.data) {
            dispatch(
              updateWorkflowInstanceAdditionalKeys({
                background_jobs_active: result?.data?.background_jobs_active,
                background_jobs_due_time:
                  result?.data?.background_jobs_due_time,
                isPolling: false,
              })
            )
            refetchWorkflow()
          }
        }
      } catch (err) {
        if (pollInterval) clearInterval(pollInterval)
      }
    }, intervalTTL)
  }

  const fetchWorkflowData = async (payload: {
    recordId: string
    entityName: string
  }) => {
    dispatch(showLoader())
    try {
      const response = await getWorkflowByEntityNameAndRecordId(payload)
      if (response?.data) {
        dispatch(updateWorkflowInstance(response?.data?.workflow_instance))
        dispatch(updateWorkflowDefinition(response?.data?.process))
        dispatch(
          updateWorkflowInstanceAdditionalKeys({
            background_jobs_active: response?.data?.background_jobs_active,
            background_jobs_due_time: response?.data?.background_jobs_due_time,
          })
        )
        if (
          response?.data?.workflow_instance?.state ===
            WORKFLOW_STATUS.PROCESSING_IN_BACKGROUND ||
          response?.data?.background_jobs_active
        ) {
          startPollingWorkflow()
        }

        fetchLayout(
          response?.data?.process?.global_variables?.entity_id,
          response?.data?.process?.global_variables?.left_split?.view_layout_id
        )
        await fetchRelationshipTree({
          entityId: response?.data?.process?.global_variables?.entity_id,
        })
      }
    } catch (err) {
      navigate(-1)
      console.error(err)
    } finally {
      setIsFetched(true)
      dispatch(hideLoader())
    }
  }

  const refetchWorkflow = () => {
    setRefetch((prev) => !prev)
    fetchWorkflowData({ recordId: caseId ?? '', entityName: 'case' })
    // resetServiceWorkerDataCache({ prewarm: false })
  }

  const resetWorkflowClick = async () => {
    return
    // try {
    //   dispatch(showLoader())
    //   const resp = await resetWorkflowApi(caseId ?? '')
    //   if (resp?.data) {
    //     refetchWorkflow()
    //   }
    // } catch (err) {
    //   console.error(err)
    // } finally {
    //   dispatch(hideLoader())
    // }
  }

  const fetchRelationshipTree = async ({ entityId }: { entityId: string }) => {
    try {
      const response = await getLayoutTree(
        entityId || '',
        FIELD_VALUE_CONSTANTS?.ONE?.toString()
      )
      if (response?.data) {
        dispatch(
          updateRelationshipTree(flattenEntityRelationshipTree(response?.data))
        )

        dispatch(
          updateRelationshipTreeObject({
            [response?.data?.entity_name ?? '']: { ...response?.data },
          })
        )
      }
    } catch (error) {
      console.log(error)
    }
  }

  const fetchCaseDetails = async () => {
    dispatch(showLoader())
    try {
      const response = await getCaseKeyCaseNameByEntity(
        {
          entity_id: Number(workflowDefinition?.global_variables?.entity_id),
          select: [
            workflowDefinition?.global_variables?.config?.case_status_name ??
              '',
            workflowDefinition?.global_variables?.config?.case_id ?? '',
          ],
          related_entities: {
            [workflowDefinition?.global_variables?.config?.case_status_name ??
            '']: {
              select: [
                workflowDefinition?.global_variables?.config
                  ?.overall_case_status ?? '',
              ],
            },
          },
        },
        workflowDefinition?.global_variables?.entity_name ?? '',
        caseId ?? ''
      )

      if (response?.data) {
        dispatch(
          updateCaseInfo({
            caseId: response?.data?.case_key,
            caseStatus:
              response?.data?.[
                workflowDefinition?.global_variables?.config
                  ?.case_status_name ?? ''
              ]?.name,
          })
        )
        setCaseDetails({
          caseId: response?.data?.case_key,
          caseStatus:
            response?.data?.[
              workflowDefinition?.global_variables?.config?.case_status_name ??
                ''
            ]?.name,
          overallCaseStatus:
            response?.data?.[
              workflowDefinition?.global_variables?.config?.case_status_name ??
                ''
            ]?.overall_case_status,
        })
      }
    } catch (err) {
      console.error(err)
    } finally {
      dispatch(hideLoader())
    }
  }

  const getCommunicationStatuses = async () => {
    try {
      const response = await generateCommuncationStatusesAPI()
      if (response) {
        setCommunicationStatuses(
          response?.data?.map((res: { label: string; id: string }) => ({
            label: res?.label,
            id: res?.id,
          }))
        )
      }
    } catch (err) {
      console.error(err)
    }
  }

  const fetchFaxDetails = async (letterDataQuery: string) => {
    try {
      const payload = {
        entity_name: QUEUE_STRINGS?.COMMUNICATION_LOWERCASE,
        select: [
          'programs',
          'created_at',
          'sender_name',
          'communication_id',
          'total_pages',
          'case',
          'category_status',
        ],
      }

      if (letterDataQuery) {
        const response = await fetchCommunicationIdCorrespondingData(
          parseInt(letterDataQuery),
          payload
        )

        const responseCommunication = await fetchEntityIdByName(
          dispatch,
          ENTITY_NAME.COMMUNICATION
        )

        if (response?.data?.communication_id && responseCommunication) {
          const communicationResponse = {
            ...response?.data,
            communication_key: responseCommunication?.id,
          }

          setFaxDetails(communicationResponse)

          dispatch(
            updateFaxDetailsReducer({
              fax_name: response?.data?.fax_name,
              communication_type: response?.data?.communication_type,
            })
          )
        }
      }
    } catch (error) {
      console.error(error)
    }
  }
  const isMoveToMIButtonVisible = () => {
    const manualMiStepIds =
      (workflowDefinition?.global_variables?.manual_mi?.step_id as string[]) ??
      []

    const hasManualMiTask =
      updatedTaskList?.some((task) =>
        manualMiStepIds?.includes(task?.step_id ?? '')
      ) ?? false

    if (!hasManualMiTask) return true

    return !(workflowDefinition?.global_variables?.manual_mi?.isHide ?? false)
  }
  const fetchCaseData = async () => {
    try {
      const searchParams = new URLSearchParams(window.location.search)
      const caseIdQuery = searchParams.get('caseId')
      const caseDataResponse = await getEntityDataByIdEntityNameEmbedded(
        'case',
        ['programs', 'services', 'users', 'products'],
        caseIdQuery || ''
      )
      dispatch(updateCaseData(caseDataResponse.data))
    } catch (err) {
      console.error(err)
    }
  }
  const getTooltipForCallIcon = (isLoggedInToAWS: boolean) =>
    !isLoggedInToAWS ? NAMESPACES.PLEASE_LOGIN_FIRST : ''

  const getClassNameForCallIcon = (isLoggedInToAWS: boolean) =>
    !isLoggedInToAWS ? 'cursor-not-allowed' : 'cursor-pointer'
  useEffect(() => {
    const handleDisable = () => {
      isFocusTrapActive.current = false
      onFocus.current = false
    }

    const handleEnable = () => {
      onFocus.current = true
      isFocusTrapActive.current = true
    }

    window.addEventListener(EVENT_CONSTANTS.DISABLE_FOCUS_TRAP, handleDisable)
    window.addEventListener(EVENT_CONSTANTS.ENABLE_FOCUS_TRAP, handleEnable)

    return () => {
      window.removeEventListener(
        EVENT_CONSTANTS.DISABLE_FOCUS_TRAP,
        handleDisable
      )
      window.removeEventListener(
        EVENT_CONSTANTS.ENABLE_FOCUS_TRAP,
        handleEnable
      )
    }
  }, [])

  useEffect(() => {
    if (!isSuperAdmin() && Object.keys(programPermissions).length === 0) return
    if (!isEmpty(workflowInstance)) {
      fetchCaseDetails()
    }
    if (
      workflowInstance &&
      workflowInstance?.state === WORKFLOW_STATUS.COMPLETED &&
      workflowDefinition
    ) {
      createStepper(workflowDefinition?.definition?.stepper || {})
      setCompletedStep(
        Object?.keys(workflowDefinition?.definition?.stepper || {}).length
      )
    } else if (workflowDefinition && workflowInstance) {
      createStepper(workflowDefinition?.definition?.stepper || {})
    }
    // Fetch letter pdf details

    if (letterDataQuery) {
      getCommunicationStatuses()
      fetchFaxDetails(letterDataQuery)
      setIsPrintLetterView(true)
    }
  }, [workflowInstance, workflowDefinition, programPermissions, refetch])

  useEffect(() => {
    if (panelGroupRef.current) {
      panelGroupRef.current?.setLayout([0.4, 0.6])
    }
    fetchWorkflowData({ recordId: caseId ?? '', entityName: 'case' })
  }, [caseId])

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const message = params.get('message')

    if (message) {
      dispatch(
        addToaster({
          id: uuid(),
          message: message,
          type: 'success',
        })
      )
      window.history.replaceState({}, document.title, window.location.pathname)
    }
    return () => {
      dispatch(resetWorkflowState())
    }
  }, [])

  useEffect(() => {
    if (viewLayout?.layout_data?.pages) {
      setTabIndexMap(
        generateTabIndexMap(
          viewLayout?.layout_data?.pages.map((page) => ({
            ...page,
            rows: page.rows.map((row) => ({
              ...row,
              label: row.label ?? '', // fallback to empty string if undefined
            })),
          })) as Page[],
          ROWS_TAB_DIFFERENCE
        )
      )
    }
  }, [viewLayout])

  useEffect(() => {
    const isVisible: SiteSettingsType =
      siteSettings?.find(
        (item: SiteSettingsType) =>
          item?.key === PAP_WORKFLOW_CONSTANTS.SHOW_MAXRTE_ICON
      ) ?? {}
    setShowMaxRTEIcon((isVisible?.value as boolean) ?? false)
  }, [siteSettings])
  useEffect(() => {
    const handlePopState = () => {
      const navObjectStringified = localStorage.getItem('workflowNavObject')
      const navObject = navObjectStringified
        ? JSON.parse(navObjectStringified)
        : {}
      if (navObjectStringified && navObject?.[tenantid?.toString() ?? '']) {
        navigate(
          `/manage-queue/dynamic-queue/${
            navObject?.[tenantid?.toString() ?? '']?.entityId
          }/${navObject?.[tenantid?.toString() ?? '']?.layoutId}/${
            navObject?.[tenantid?.toString() ?? '']?.Id
          }`
        )
      } else {
        navigate(-1)
      }
    }
    // window.history.pushState(null, '', window.location.href) //todo will figure out if required or not
    window.addEventListener('popstate', handlePopState)

    return () => {
      window.removeEventListener('popstate', handlePopState)
    }
  }, [navigate])

  useEffect(() => {
    fetchCaseData()
    return () => {
      dispatch(updateCaseData(null))
    }
  }, [])

  useEffect(() => {
    const handler = (e: Event) => {
      const el = e.target as HTMLElement
      if (el.getAttribute('role') === 'tab') {
        navigate(`${location.pathname}?tabs=${el.textContent?.trim()}`, {
          replace: true,
        })
      }
    }

    document.addEventListener('click', handler)
    return () => document.removeEventListener('click', handler)
  }, [])
  useEffect(() => {
    const params = new URLSearchParams(location.search)
    const requestedTab = decodeURIComponent(params.get('tabs') || '')

    if (!requestedTab) return

    setTimeout(() => {
      const tabEls = Array.from(document.querySelectorAll('[role="tab"]'))

      const matchingTab = tabEls.find(
        (el) =>
          el.textContent?.trim().toLowerCase() === requestedTab.toLowerCase()
      )

      if (matchingTab) {
        ;(matchingTab as HTMLElement).click()
        matchingTab.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
      }
    }, 200)
  }, [location.search, viewLayout])

  return (
    <>
      {isAddTask && (
        <WorkflowAddManualTaskModal
          setIsAddTask={setIsAddTask}
          isAddTask={isAddTask}
          createTask={createTask}
        />
      )}
      {!workflowInstance &&
      !workflowDefinition &&
      !loaderVisible &&
      isFetched ? (
        <div className="h-screen w-full flex items-center justify-center bg-gray-50">
          <div className="flex flex-col items-center justify-center p-8 bg-white rounded-lg shadow-sm max-w-2xl mx-6">
            <div className="w-16 h-16 mb-4 text-gray-400">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </div>
            <h3 className="text-base font-semibold text-gray-700 mb-2">
              {NAMESPACES.WORKFLOW_DEFINITION_DEPRECATED_LABEL}
            </h3>
            <p className="text-gray-500 text-center max-w-md mb-6">
              {NAMESPACES.WORKFLOW_DEFINITION_DEPRECATED_DESCRIPTION}
            </p>
          </div>
        </div>
      ) : null}
      {!isEmpty(workflowDefinition) ? (
        <FocusTrap
          active={isFocusTrapActive.current}
          focusTrapOptions={{
            allowOutsideClick: true,
            escapeDeactivates: true,
            setReturnFocus: false,
            clickOutsideDeactivates: true,
            onDeactivate: () => {
              isFocusTrapActive.current = false
            },
          }}
        >
          <div
            ref={leftPanelRef}
            onFocus={() => {
              if (onFocus.current) {
                isFocusTrapActive.current = true
              }
            }}
            className="h-full"
          >
            <PanelGroup
              direction="horizontal"
              ref={panelGroupRef}
              // className="resize-panel-group flex flex-col w-full h-screen"
              autoSaveId="example"
            >
              {/* Left Panel */}

              <Panel
                id="left-panel"
                defaultSize={35}
                className="overflow-y-auto max-h-screen flex flex-col"
              >
                <div className="flex flex-row gap-3 justify-between mx-1 my-1 p-2.5 bg-gray-100 items-center">
                  <span className="font-primary font-medium text-base flex items-center">
                    {caseDetails?.caseId}
                    {isMoveToMIButtonVisible() && (
                      <MissingInfoIcon
                        caseDetails={caseDetails}
                        refetchWorkflow={refetchWorkflow}
                      />
                    )}
                  </span>
                  <span className="font-primary font-light text-base mr-3 flex flex-row gap-2 items-center">
                    {caseDetails?.caseStatus}
                    <span className="bg-secondary-25 rounded-md px-2 py-0.5 ml-2">
                      {caseDetails?.overallCaseStatus ?? ''}
                    </span>
                    {!isReadOnlyUser() ? (
                      <CaseStateWorkflow
                        caseId={caseId ?? 0}
                        refetchWorkflow={refetchWorkflow}
                        workflowInstanceId={workflowInstance?.id ?? 0}
                        entityId={entityId}
                        voidData={
                          workflowDefinition?.global_variables?.case_management
                            ?.void
                        }
                        closeData={
                          workflowDefinition?.global_variables?.case_management
                            ?.close
                        }
                        overallCaseStatus={caseDetails?.overallCaseStatus}
                        faxDetails={faxDetails}
                        onCaseDataUpdate={fetchCaseData}
                      />
                    ) : null}
                  </span>
                </div>
                {isEmpty(viewLayout) ? (
                  <LeftSplitShimmer />
                ) : viewLayout?.type === LAYOUT_TYPE_NAMESPACE.TABS_TYPE ? (
                  <div className="flex-1 min-h-0 mb-2">
                    <div className="overflow-y-auto h-full">
                      <div className="p-1">
                        {caseId && (
                          <TabLayout
                            layout={viewLayout}
                            isWorkflow={true}
                            recordId={caseId}
                            entityId={entityId ?? ''}
                            tabIndexMap={tabIndexMap}
                            tabIndexForTabs={ROWS_TAB_DIFFERENCE - 1}
                            isPrintLetterView={isPrintLetterView}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                ) : (
                  entityData && (
                    <div className="mt-3 border border-tertiary-300 rounded overflow-y-auto h-[81vh]">
                      <div className="px-3 pb-3">
                        <FormRenderer
                          heading={undefined}
                          layout={viewLayout?.layout_data as LayoutData}
                          mode={'view'}
                          handleFormSubmit={noop}
                          fullLayout={viewLayout as EntityLayout}
                          data={entityData}
                          tabIndexMap={tabIndexMap}
                        />
                      </div>
                    </div>
                  )
                )}
              </Panel>

              <PanelResizeHandle />

              {/* Right Panel */}
              <Panel
                id="right-panel"
                defaultSize={65}
                className="overflow-y-auto max-h-screen"
              >
                {!faxDetails ? (
                  <div className="flex flex-col w-full h-full border-l border-tertiary-300">
                    <div className="p-2.5 m-auto overflow-x-auto flex w-full justify-center items-center border-b border-tertiary-300">
                      <StepperBV
                        steps={stepper ?? []}
                        currentStep={completedStep ?? 0}
                      />
                    </div>

                    {(workflowInstanceAdditionalKeys?.isPolling ||
                      workflowInstanceAdditionalKeys?.background_jobs_active ||
                      workflowInstance?.state ===
                        WORKFLOW_STATUS.PROCESSING_IN_BACKGROUND) && (
                      <div className="mx-2 my-1 bg-yellow-100 p-3">
                        <span className=" font-medium  rounded-md">
                          {STRINGS.PROGRESS_BANNER_TEXT}
                          {STRINGS.PROGRESS_WORKFLOW_REFRESH_TEXT_START}
                          <button
                            onClick={() => refetchWorkflow()}
                            className="text-blue-600 font-medium"
                          >
                            Refresh
                          </button>{' '}
                          {STRINGS.PROGRESS_WORKFLOW_REFRESH_TEXT_END}
                        </span>
                      </div>
                    )}
                    <div className="flex-1 min-h-0 flex flex-col overflow-hidden task_list_container_outer">
                      <div className="px-2 pt-1 w-full bg-white">
                        {workflowDefinition?.global_variables?.sticky_summary
                          ?.entity_id &&
                          workflowDefinition?.global_variables?.sticky_summary
                            ?.layout_id && (
                            <div className="bg-gray-100 p-1">
                              <StickySummary
                                workflowDefinition={workflowDefinition}
                                recordId={caseId ?? ''}
                              />
                            </div>
                          )}
                        {workflowDefinition?.global_variables
                          ?.sub_sticky_summary?.entity_id &&
                          workflowDefinition?.global_variables
                            ?.sub_sticky_summary?.layout_id && (
                            <div className="bg-gray-100 p-1">
                              <SubStickySummary
                                workflowDefinition={workflowDefinition}
                                recordId={caseId ?? ''}
                                isDisable={
                                  caseDetails?.overallCaseStatus ===
                                    STRINGS.CLOSED ||
                                  caseDetails?.overallCaseStatus ===
                                    STRINGS.VOID
                                }
                              />
                            </div>
                          )}
                        <div className="pt-2 border-b-2" />
                      </div>
                      <div className="p-3 pt-2 z-[1] flex flex-col flex-1 min-h-0 task_list_container">
                        <div className="flex justify-between items-center">
                          <span className="font-primary text-base">
                            Task List
                          </span>
                          {!isReadOnlyUser() ? (
                            <div className="flex items-center gap-2 cursor-pointer">
                              {caseDetailsVal?.caseId?.startsWith(
                                MAX_RTE_NAME_SPACE.BV_ID_PREFIX
                              ) &&
                                showMaxRTEIcon && (
                                  <CheckEligibilityMaxRTE
                                    from={CHECK_ELIGIBILITY_LOCATION.CASE}
                                    showDivider={false}
                                  />
                                )}
                              {MEC_PORTAL_BTN && (
                                <div className="ml-4">
                                  <PatientEConsent
                                    from={CHECK_ELIGIBILITY_LOCATION.CASE}
                                  />
                                </div>
                              )}
                              <div className="ml-4">
                                {caseDetails?.overallCaseStatus !==
                                STRINGS.CLOSED ? (
                                  <>
                                    <MoveToMIProcess
                                      refetchWorkflow={refetchWorkflow}
                                      recordId={caseId ?? ''}
                                      tabIndex={
                                        ROWS_TAB_DIFFERENCE_FOR_WORK_FOW - 1
                                      }
                                      isDisabled={
                                        caseDetails?.overallCaseStatus ===
                                          STRINGS.VOID ||
                                        caseDetails?.overallCaseStatus ===
                                          STRINGS.CLOSED
                                      }
                                    />
                                    <div
                                      className="pr-1"
                                      onClick={async () => {
                                        await createFaxTask()
                                        setRefetch(!refetch)
                                      }}
                                    >
                                      <SvgFaxIconWorkflow className="w-5 h-5 svg-rect-fill-none hidden" />{' '}
                                      {/* NOTE: Hiding it for now after Fax Outbound Task is created */}
                                    </div>
                                    {getEnableCall() ? (
                                      <Tooltip
                                        content={getTooltipForCallIcon(
                                          isLoggedInToAWS
                                        )}
                                        className="hidden"
                                      >
                                        <SvgCallIconWorkflow
                                          onClick={async () => {
                                            if (isLoggedInToAWS) {
                                              await createCallTask({
                                                taskName:
                                                  NAMESPACES.FOLLOW_UP_CALL,
                                                taskSummary:
                                                  NAMESPACES.FOLLOW_UP_CALL,
                                                status: TASK_STATUS.PENDING,
                                              })
                                              setRefetch(!refetch)
                                              if (isLoggedInToAWS) {
                                                dispatch(setDialPad(''))
                                              }
                                            }
                                          }}
                                          className={`w-3 hidden h-3 ${getClassNameForCallIcon(
                                            isLoggedInToAWS
                                          )}`}
                                          tabIndex={
                                            ROWS_TAB_DIFFERENCE_FOR_WORK_FOW - 1
                                          }
                                          onKeyDown={async (e) => {
                                            if (
                                              e.key === ShortcutKeys.Enter ||
                                              e.key === ShortcutKeys.Space
                                            ) {
                                              e?.preventDefault()
                                              if (isLoggedInToAWS) {
                                                await createCallTask({
                                                  taskName:
                                                    NAMESPACES.FOLLOW_UP_CALL,
                                                  taskSummary:
                                                    NAMESPACES.FOLLOW_UP_CALL,
                                                  status: TASK_STATUS.PENDING,
                                                })
                                                setRefetch(!refetch)
                                                if (isLoggedInToAWS) {
                                                  dispatch(setDialPad(''))
                                                }
                                              }
                                            }
                                          }}
                                        />
                                      </Tooltip>
                                    ) : null}
                                  </>
                                ) : null}
                              </div>
                              {workflowInstanceAdditionalKeys?.background_jobs_active && (
                                <div
                                  className="truncate"
                                  onClick={() => {
                                    refetchWorkflow()
                                  }}
                                >
                                  <SvgReload />
                                </div>
                              )}
                              <CustomButton
                                widthClass="w-[5.313rem]"
                                onClick={toggleAddTask}
                                verticalPaddingClasses="py-2"
                                horizontalPaddingClasses="ml-4 px-4"
                                tabIndex={ROWS_TAB_DIFFERENCE_FOR_WORK_FOW - 1}
                                disabled={
                                  caseDetails?.overallCaseStatus ===
                                  STRINGS.VOID
                                }
                              >
                                {NAMESPACES.ADD_TASK}
                              </CustomButton>
                              {isSuperAdmin() ||
                              programPermissions[
                                caseData?.programs?.id?.toString() || ''
                              ]?.['Reopen Work']?.Manage ? (
                                <div className="hidden">
                                  <CustomButton
                                    isFilled
                                    onClick={resetWorkflowClick}
                                  >
                                    {STRINGS.RESET_WORKFLOW}
                                  </CustomButton>
                                </div>
                              ) : null}
                            </div>
                          ) : null}
                        </div>
                        <div className="flex w-full flex-1 min-h-0">
                          <WorkflowRightSplitTaskTable
                            recordId={caseId ?? ''}
                            reFetch={refetch}
                            refetchWorkflow={refetchWorkflow}
                            overallCaseStatus={caseDetails?.overallCaseStatus}
                            createTask={createTask}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <LetterPreview
                    faxDetails={faxDetails}
                    communicationStatuses={communicationStatuses}
                  />
                )}
              </Panel>
            </PanelGroup>
          </div>
        </FocusTrap>
      ) : null}
    </>
  )
}

export default WorkflowReview
